import { USER_ROLES as ROLES } from './main';

export const LOAN_FILE_STATUSES = [
  { value: 'Pending', label: 'Pending' },
  { value: 'Incomplete', label: 'Incomplete' },
  { value: 'Underwriting', label: 'Underwriting' },
  { value: 'Pre-approved', label: 'Pre-approved' },
  { value: 'Approved', label: 'Approved' },
  { value: 'Clear to Close', label: 'Clear to Close' },
  { value: 'Clear to Close - Funding', label: 'Clear to Close - Funding' },
  { value: 'Originated', label: 'Originated' },
  { value: 'Approved - Not Accepted', label: 'Approved - Not Accepted' },
  { value: 'Denied - Pre-Approval', label: 'Denied - Pre-Approval' },
  { value: 'Withdrawn', label: 'Withdrawn' },
  { value: 'Denied', label: 'Denied' },
  { value: 'Closed for Incompleteness', label: 'Closed for Incompleteness' },
  { value: 'Archived', label: 'Archived' },
];

export const US_STATES = [
  { value: 'AL', label: 'Alabama' },
  { value: 'AK', label: 'Alaska' },
  { value: 'AZ', label: 'Arizona' },
  { value: 'AR', label: 'Arkansas' },
  { value: 'CA', label: 'California' },
  { value: 'CO', label: 'Colorado' },
  { value: 'CT', label: 'Connecticut' },
  { value: 'DE', label: 'Delaware' },
  { value: 'FL', label: 'Florida' },
  { value: 'GA', label: 'Georgia' },
  { value: 'HI', label: 'Hawaii' },
  { value: 'ID', label: 'Idaho' },
  { value: 'IL', label: 'Illinois' },
  { value: 'IN', label: 'Indiana' },
  { value: 'IA', label: 'Iowa' },
  { value: 'KS', label: 'Kansas' },
  { value: 'KY', label: 'Kentucky' },
  { value: 'LA', label: 'Louisiana' },
  { value: 'ME', label: 'Maine' },
  { value: 'MD', label: 'Maryland' },
  { value: 'MA', label: 'Massachusetts' },
  { value: 'MI', label: 'Michigan' },
  { value: 'MN', label: 'Minnesota' },
  { value: 'MS', label: 'Mississippi' },
  { value: 'MO', label: 'Missouri' },
  { value: 'MT', label: 'Montana' },
  { value: 'NE', label: 'Nebraska' },
  { value: 'NV', label: 'Nevada' },
  { value: 'NH', label: 'New Hampshire' },
  { value: 'NJ', label: 'New Jersey' },
  { value: 'NM', label: 'New Mexico' },
  { value: 'NY', label: 'New York' },
  { value: 'NC', label: 'North Carolina' },
  { value: 'ND', label: 'North Dakota' },
  { value: 'OH', label: 'Ohio' },
  { value: 'OK', label: 'Oklahoma' },
  { value: 'OR', label: 'Oregon' },
  { value: 'PA', label: 'Pennsylvania' },
  { value: 'RI', label: 'Rhode Island' },
  { value: 'SC', label: 'South Carolina' },
  { value: 'SD', label: 'South Dakota' },
  { value: 'TN', label: 'Tennessee' },
  { value: 'TX', label: 'Texas' },
  { value: 'UT', label: 'Utah' },
  { value: 'VT', label: 'Vermont' },
  { value: 'VA', label: 'Virginia' },
  { value: 'WA', label: 'Washington' },
  { value: 'WV', label: 'West Virginia' },
  { value: 'WI', label: 'Wisconsin' },
  { value: 'WY', label: 'Wyoming' },
];

export const LOAN_FILE_DOCUMENT_TYPES = [
  { label: '1003', value: '1003' },
  { label: 'Photo ID', value: 'Photo ID' },
  { label: 'ITIN Letter', value: 'ITIN Letter' },
  { label: 'Social Security Card', value: 'Social Security Card' },
  { label: 'Bank Statement', value: 'Bank Statement' },
  { label: 'W2', value: 'W2' },
  { label: 'Paystub', value: 'Paystub' },
  { label: 'Tax Return', value: 'Tax Return' },
  { label: 'Other Income', value: 'Other Income' },
  { label: 'Credit Report - Soft Pull', value: 'Credit Report - Soft Pull' },
  { label: 'Credit Report - Hard Pull', value: 'Credit Report - Hard Pull' },
  { label: 'VOR', value: 'VOR' },
  {
    label: 'Real Estate: Mortgage Statement',
    value: 'Real Estate: Mortgage Statement',
  },
  { label: 'Real Estate: Insurance', value: 'Real Estate: Insurance' },
  { label: 'Real Estate: Tax Statement', value: 'Real Estate: Tax Statement' },
  { label: 'Real Estate: Lease', value: 'Real Estate: Lease' },
];

export const USER_ROLES = [
  { label: 'Owner', value: ROLES.owner },
  { label: 'Loan Officer', value: ROLES.loanOfficer },
  { label: 'Administrative', value: ROLES.administrative },
];
